// extracted by mini-css-extract-plugin
module.exports = {"container":"document-link_container__2nWN1","link":"document-link_link__2DEhc","green":"document-link_green__33UGp"};